module.exports = "/images/hands.png?b0f2fd1ce92dcf46589877671edce722";